import React from "react"
import { useDispatch } from "react-redux"

import closeIcon from "@/public/icons/close-white.svg"
import { setAuthModalVisibility } from "@/store/features/authSlice"
import styles from "@/components/core/GlobalToaster/Toaster/index.module.scss"
import htmlParser from "html-react-parser"
import _isEmpty from "lodash/isEmpty"

const Toaster = props => {
  const {
    authData: { toasterMessage = "", createAccountCTA = "", signInCTA = "" },
    setShowToaster = () => {},
  } = props

  const isCreateCTA = _isEmpty(createAccountCTA)
  const isSignInCTA = _isEmpty(signInCTA)
  const showOr = !isCreateCTA && !isSignInCTA

  const dispatch = useDispatch()

  const handleClose = () => {
    setShowToaster(false)
  }

  const onClickSignIn = () => {
    dispatch(setAuthModalVisibility({ show: true }))
  }
  const onClickSignUp = () => {
    dispatch(setAuthModalVisibility({ show: true, active: 1 }))
  }
  return (
    <div className={styles.wrapper}>
      <div className="banner-container">
        <div className="banner-msg">
          {htmlParser(toasterMessage)}
          <span>
            {!isCreateCTA ? (
              <p className="linkCTA" onClick={e => onClickSignUp(e)}>
                {createAccountCTA}
              </p>
            ) : null}
            {showOr ? <span> or </span> : null}
            {!isSignInCTA ? (
              <p className="linkCTA" onClick={e => onClickSignIn(e)}>
                {signInCTA}
              </p>
            ) : null}
          </span>
        </div>

        <div className="banner-close">
          <img src={closeIcon?.src} alt="close" onClick={handleClose} />
        </div>
      </div>
    </div>
  )
}

export default Toaster
